import React, {useEffect, useState} from "react";
import {AddButton} from "../../../helpers/ButtonHelper";
import {saveData} from "../../../helpers/Api";
import {Modal} from "react-bootstrap";
import {useMutation} from "@apollo/client";
import MenuPlateForm from "./MenuPlateForm";
import {AddMenuPlateMutation, getMenuPlates} from "./MenuQueries";

const AddPlateIngredientModal = ({
                                   menuId,
                                   onClose,
                                   shouldOpen,
                                   showButton
                                 }) => {
  const [show, setShow] = useState(false);
  const [flash, setFlash] = useState({});
  const [gqlCall] = useMutation(AddMenuPlateMutation, {refetchQueries: [getMenuPlates]})

  let menuPlate = {
    menuId: menuId,
    plateId: null,
    day: 1,
    categoryId: null,
  }

  const closeModal = () => {
    setFlash({})
    setShow(false);
    if (onClose) onClose();
    // resetForm();
  }
  const showModal = (e) => {
    e.preventDefault()
    setShow(true);
  }

  useEffect(() => {
    if (shouldOpen) {
      showModal(true)
    }
  }, [shouldOpen])

  const onSubmit = (event) => {
    event.preventDefault()
    console.log('submit')
    saveData({
      event: event,
      gqlCall: gqlCall,
      query_key: 'addMenuItem',
      success: (res) => {
        closeModal()
      },
      flash_callback: setFlash
    })
  }

  return (
    <>
      {showButton && <AddButton to='#' onClick={showModal} size='sm'/>}

      <Modal show={show} onHide={closeModal} size="lg">
        <Modal.Header closeButton>
          <Modal.Title>Adauga o masa</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="container">
            <div className="row justify-content-md-center">
              <MenuPlateForm
                onSubmit={onSubmit}
                menuPlate={menuPlate}
                flash={flash}/>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  )
};

export default AddPlateIngredientModal;